export default "__VITE_ASSET__bdg41Tg4__"